// Google Analytics 4 Custom Event Tracking

declare global {
  interface Window {
    gtag: (...args: unknown[]) => void;
    dataLayer: unknown[];
  }
}

// Track CTA button clicks
export const trackCTAClick = (ctaName: string, ctaLocation: string) => {
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('event', 'cta_click', {
      cta_name: ctaName,
      cta_location: ctaLocation,
    });
  }
};

// Track video play
export const trackVideoPlay = (videoName: string) => {
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('event', 'video_play', {
      video_name: videoName,
    });
  }
};

// Track form submission (email capture)
export const trackFormSubmission = (formName: string) => {
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('event', 'form_submission', {
      form_name: formName,
    });
  }
};

// Track scroll to section
export const trackSectionView = (sectionName: string) => {
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('event', 'section_view', {
      section_name: sectionName,
    });
  }
};

// Track add to cart / begin checkout
export const trackBeginCheckout = (value: number, currency: string = 'USD', items?: unknown[]) => {
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('event', 'begin_checkout', {
      currency,
      value,
      items,
    });
  }
};

// Track purchase conversion
export const trackPurchase = (transactionId: string, value: number, currency: string = 'USD', items?: unknown[]) => {
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('event', 'purchase', {
      transaction_id: transactionId,
      currency,
      value,
      items,
    });
  }
};

// Track upsell offer view
export const trackOfferView = (offerName: string, offerValue: number) => {
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('event', 'offer_view', {
      offer_name: offerName,
      offer_value: offerValue,
    });
  }
};

// Track upsell offer acceptance
export const trackOfferAccept = (offerName: string, offerValue: number) => {
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('event', 'offer_accept', {
      offer_name: offerName,
      offer_value: offerValue,
    });
  }
};

// Track upsell offer decline
export const trackOfferDecline = (offerName: string) => {
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('event', 'offer_decline', {
      offer_name: offerName,
    });
  }
};

// Track page view with custom parameters
export const trackPageView = (pagePath: string, pageTitle: string) => {
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('event', 'page_view', {
      page_path: pagePath,
      page_title: pageTitle,
    });
  }
};
